import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SharedService {
     constructor(){

     }
     subject = new Subject<void>();

} 


// WEBPACK FOOTER //
// ./src/app/services/SharedService/cheque.service.ts